import React from 'react';
import { makeStyles } from '~/UIKit/Style';
import { TIME_WIDTH } from '~/Screens/Calendar/constants';
import {
  calculateNewEvent,
  CalendarDragLayer,
  CalendarHours,
  DraggableType,
  IGetEventPosition,
} from '~/Screens/Calendar/CalendarView/components';
import { ICalendarOffset } from '~/Screens/Calendar/interfaces';

const useStyles = makeStyles(
  () => ({
    content: {
      overflow: 'hidden scroll',
      maxHeight: '100%',
      position: 'relative',
    },
    view: {
      marginLeft: TIME_WIDTH,
    },
  }),
  { name: 'CalendarViewContent' },
);

interface IMonthlyView {
  offset: ICalendarOffset;
  children: React.ReactNode;
  hasToday: boolean;
  setOffset: React.Dispatch<React.SetStateAction<ICalendarOffset>>;
  getEventPosition: IGetEventPosition;
}

export const CalendarViewContent = ({
  offset,
  hasToday,
  children,
  setOffset,
  getEventPosition,
}: IMonthlyView) => {
  const { classes } = useStyles();

  return (
    <div className={classes.content}>
      <div className={classes.view}>{children}</div>
      <CalendarDragLayer
        offset={offset}
        calendarType={DraggableType.EVENT}
        getEventPosition={getEventPosition}
        calculateNewEvent={calculateNewEvent}
      />
      <CalendarHours setOffset={setOffset} hasToday={hasToday} />
    </div>
  );
};
